import Vue from 'vue';
import Vuex from 'vuex';

import CmsContent from './modules/cms-content';
import UsedSearchOptions from './modules/used-search-options';
import Dealers from './modules/dealers';
import CustomerData from './modules/customer-data';
import FinanceParameters from './modules/finance-parameters';
import Layout from './modules/layout';
import Auth from '../../core/modules/Auth/auth';
import RepresentativeExample from './modules/representative-example';
import Valuations from './modules/valuations';
import CarAlert from './modules/car-alert';
import BuyOnline from './modules/buy-online';
import VynePayment from './modules/vyne-payment';

// Campaign
// import CampaignStore from './modules/Campaign/2018/jan-sale';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        CmsContent,
        UsedSearchOptions,
        Dealers,
        CustomerData,
        FinanceParameters,
        Layout,
        Auth,
        RepresentativeExample,
        Valuations,
        CarAlert,
        BuyOnline,
        VynePayment

        // Campaign
        // CampaignStore,
    },
    strict: debug,
});